import { render, staticRenderFns } from "./BcTransactionLinks.vue?vue&type=template&id=70e56da2&scoped=true"
import script from "./BcTransactionLinks.vue?vue&type=script&lang=js"
export * from "./BcTransactionLinks.vue?vue&type=script&lang=js"
import style0 from "./BcTransactionLinks.vue?vue&type=style&index=0&id=70e56da2&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e56da2",
  null
  
)

export default component.exports